import { Amplify } from 'aws-amplify';

// Get environment variables
const userPoolId = import.meta.env?.VITE_COGNITO_USER_POOL_ID;
const userPoolClientId = import.meta.env?.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID;
const identityPoolId = import.meta.env?.VITE_COGNITO_IDENTITY_POOL_ID;

// Validate required environment variables
if (!userPoolId || !userPoolClientId || !identityPoolId) {
  console.error('Missing required AWS Cognito configuration:');
  console.error('VITE_COGNITO_USER_POOL_ID:', userPoolId);
  console.error('VITE_COGNITO_USER_POOL_WEB_CLIENT_ID:', userPoolClientId);
  console.error('VITE_COGNITO_IDENTITY_POOL_ID:', identityPoolId);
  throw new Error('AWS Cognito configuration is missing. Please check your .env.local file.');
}

// AWS Cognito configuration for Amplify
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      identityPoolId,
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true,
        },
      },
    },
  },
};

console.log('Configuring Amplify with:', {
  userPoolId,
  userPoolClientId: userPoolClientId.substring(0, 8) + '...',
  identityPoolId: identityPoolId.substring(0, 20) + '...'
});

// Initialize Amplify with Cognito configuration
Amplify.configure(amplifyConfig);

export default amplifyConfig;